export default __webpack_public_path__ + "static/media/rooms.691050b8.svg";